import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StageTimelineStep } from './stage-timeline-step';

/**
 * Linha do tempo vertical da jornada (Visão do Cliente, card 3461; protótipo aprovado em 19/10/2026,
 * "Sua jornada com a Legatus").
 *
 * Só desenha: recebe as etapas prontas (`steps`) e não sabe nada de deal. Feita = bolinha verde com
 * check; atual = anel verde, fundo verde-claro e o selo "Agora"; dispensada = verde-clara com o selo
 * "Dispensada"; futura = cinza. O traço entre as bolinhas fica verde até a atual.
 */
@Component({
  selector: 'app-client-stage-timeline',
  standalone: true,
  templateUrl: './client-stage-timeline.component.html',
  styleUrl: './client-stage-timeline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientStageTimelineComponent {
  readonly steps = input<StageTimelineStep[]>([]);

  /** Texto lido pelo leitor de tela para cada etapa. */
  protected describe(step: StageTimelineStep): string {
    switch (step.progress) {
      case 'Done':
        return `${step.label}: concluída`;
      case 'Skipped':
        return `${step.label}: dispensada`;
      case 'Current':
        return `${step.label}: etapa atual`;
      default:
        return `${step.label}: próxima`;
    }
  }
}
